import styled, {css} from 'styled-components'

export const Track = (props, state) => (
  <StyledTrack {...props} index={state.index}></StyledTrack>
)

const StyledTrack = styled.div( ({index}) => css`
  height: 1px;
  position: absolute;
  background: ${ ( index === 2 ) ? window.clr?.primary_text : ( index === 1 ) ? window.clr?.primary_text : window.clr?.primary_text };
`)